// extracted by mini-css-extract-plugin
module.exports = {"container":"VerificationPending_container__uVBnh","title":"VerificationPending_title__rX7yI","description":"VerificationPending_description__1VhYU"};